/**
 * @desc 基座页面路由
 * @time 2023-07-31 15:41:53
 * @user simxin
 */

import ReactDOM from 'react-dom';
import { t } from '@src/utils/translate';
import { ConfigProvider } from '@tencent/tea-component';
import en_US from '@tencent/tea-component/lib/i18n/locale/en_US';
import zh_CN from '@tencent/tea-component/lib/i18n/locale/zh_CN';
import ko_KR from '@tencent/tea-component/lib/i18n/locale/ko_KR';
import ja_JP from '@tencent/tea-component/lib/i18n/locale/ja_JP';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, LayoutHeader, LayoutBody } from '@src/component/layout/full';
import { LoadingStatus } from '@src/component/loading';
import { usePortalStore } from '@src/store';
import { Products } from './products';
import { isSimpleAppMode } from '@src/utils/tools';
import { isMobile } from 'react-device-detect';
import { MobileGuide } from '@tencent/tpm-trtc-console';
import { LayoutNavPlanB } from '@src/component/layout/nav-planb';

const App = () => {
  const loadedPortal = usePortalStore(state => state.loadedPortal);

  return loadedPortal ? (
    <BrowserRouter>
      <Layout className="new-console">
        <LayoutHeader>
          <LayoutNavPlanB />
        </LayoutHeader>
        <LayoutBody>
          {isSimpleAppMode() ? (
            <Routes>
              <Route path="/" element={<Products />} />
              <Route path="/:menu" element={<Products />} />
              <Route path="/:menu/:submenu" element={<Products />} />
              <Route path="/:menu/:submenu/*" element={<Products />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<Navigate to="/trtc" replace />} />
              <Route path="/:app" element={<Products />} />
              <Route path="/:app/:menu" element={<Products />} />
              <Route path="/:app/:menu/:submenu" element={<Products />} />
              <Route path="/:app/:menu/:submenu/*" element={<Products />} />
            </Routes>
          )}
        </LayoutBody>
      </Layout>
    </BrowserRouter>
  ) : (
    <LoadingStatus />
  );
};

const localMap = {
  en: en_US,
  zh: zh_CN,
  jp: ja_JP,
  ko: ko_KR,
};
/**
 * @desc 需要修改tea组件样式类名前缀
 * @doc https://tapd.woa.com/qcloud_cdn_inner/markdown_wikis/show/#1210145441002541623@toc14
 */
export const routes = () => {
  const root = document.getElementById('root');
  ReactDOM.render(
    <ConfigProvider
      classPrefix={'trtc-tea'}
      locale={localMap[window.VERSION] || localMap.en}
    >
      <App />
      {isMobile && (
        <MobileGuide
          guidePoster={t('Get the best console experience on the PC side')}
          jumpPcText={t('Copy Link for PC')}
          continueText={t('Continue on Mobile')}
          copyText={window.location.href}
        />
      )}
    </ConfigProvider>,
    root,
  );
};
